import { BlocksHeader } from 'blocks-nextjs/blocks-web-components/components/header/header';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatHeader = createComponent({ react: React, tagName: 'cat-header', elementClass: BlocksHeader });
